import React, { useEffect } from 'react';
import { useMsal } from "@azure/msal-react";

const Logout = () => {
    const { instance } = useMsal();
    useEffect(() => {
      signout()
    },[])

    const signout = () => {
        instance.logoutRedirect().catch(e => {
            console.error(e);
        })
    }
    

    return (
      <div className="container-fluid">
        <span>Signout...</span>
      </div>
 
    );

}

export default Logout